const isObjectEmpty = object => {
  return Object.keys(object).length === 0;
};

export default isObjectEmpty;
